import {
  useIntl 
} from "react-intl"

import {
  useStyle 
} from "../../classify"
import defaultClasses from "./message.module.css"

const Message = (props) => {
  const {
    children, classes: propClasses, fieldState = {} 
  } = props
  const {
    formatMessage 
  } = useIntl()
  const {
    error 
  } = fieldState

  const classes = useStyle(defaultClasses, propClasses)
  const className = error ? classes.root_error : classes.root
  let translatedErrorMessage

  if (error) {
    try {
      translatedErrorMessage = formatMessage(
        {
          id: error.id,
          defaultMessage: error.defaultMessage,
        },
        {
          value: error.value 
        }
      )
    } catch (error) {

    }
  }

  return <p className={className}>{translatedErrorMessage || children}</p>
}

export default Message
